import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminEmployeesPage from "@/pages/admin/AdminEmployeesPage";

export const Route = createFileRoute("/_admin/admin/employees")({
  head: () => pageHead("Admin · Employees", "AKIVA admin · employees portal.", "/admin/employees", true),
  component: AdminEmployeesPage,
});
